"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.DailyScheduleModel = void 0;
const types_1 = require("../types");
const CommonScheduleModel_1 = require("./CommonScheduleModel");
class DailyScheduleModel extends CommonScheduleModel_1.CommonScheduleModel {
    constructor(initialValue) {
        super(initialValue);
        this.isDailyKindEveryday = () => {
            return this.getValue().fields.kind === types_1.DAILY_SCHEDULE_KINDS.everyday;
        };
        this.isDailyKindWeekdays = () => {
            return this.getValue().fields.kind === types_1.DAILY_SCHEDULE_KINDS.weekDays;
        };
        this.isDailyKindSelectedDays = () => {
            return this.getValue().fields.kind === types_1.DAILY_SCHEDULE_KINDS.selectedDays;
        };
        this.getDaysIndex = () => {
            return this.getValue().fields.days.map((dayOfWeek) => types_1.DAY_INDEX[dayOfWeek]);
        };
    }
}
exports.DailyScheduleModel = DailyScheduleModel;
//# sourceMappingURL=DailyScheduleModel.js.map